var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("extra-fields"))),
                      ]),
                      _c(
                        "w-list",
                        [
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/clients",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("clients"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/suppliers",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("suppliers"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/prospects",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("prospects"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/products",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("products"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/sales",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("sales"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/sale-rows",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("sale-rows"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/purchases",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("purchases"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: { to: "/settings/extra-field-names/bank" },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("bank"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: { to: "/settings/extra-field-names/cars" },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("cars"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: { to: "/settings/extra-field-names/crm" },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("crm"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/ledger-accounts",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("ledger-accounts"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/extra-field-names/project",
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("project"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }